function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".toggle_bb_active_svg__cls-1,.toggle_bb_active_svg__cls-2{fill:rgba(108,255,0,.49)}.toggle_bb_active_svg__cls-1{stroke:#6cff00}.toggle_bb_active_svg__cls-3{stroke:none}.toggle_bb_active_svg__cls-4{fill:none}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "toggle_bb_active_svg__Rectangle_7955",
  className: "toggle_bb_active_svg__cls-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h17v17H0z",
  className: "toggle_bb_active_svg__cls-3",
  transform: "translate(.043 3.018)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h16v16H.5z",
  className: "toggle_bb_active_svg__cls-4",
  transform: "translate(.043 3.018)"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "toggle_bb_active_svg__Rectangle_7956",
  className: "toggle_bb_active_svg__cls-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  className: "toggle_bb_active_svg__cls-3",
  transform: "translate(4.043 .018)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.5.5h15v15H.5z",
  className: "toggle_bb_active_svg__cls-4",
  transform: "translate(4.043 .018)"
}));
var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "toggle_bb_active_svg__Path_9749",
  d: "M0 0h16l-3.7 3.4H-3.238l1.461-1.536z",
  className: "toggle_bb_active_svg__cls-2",
  transform: "translate(4.043 .018)"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "toggle_bb_active_svg__Path_9750",
  d: "M12.249 2.959L16 0l-.355 16-3.019 3.135z",
  className: "toggle_bb_active_svg__cls-2",
  transform: "translate(4.043 .018)"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "toggle_bb_active_svg__Path_9745",
  d: "M4.027 1.982l1.595.1-3.917 3.1L0 5z",
  className: "toggle_bb_active_svg__cls-2",
  transform: "translate(.043 -1.982)"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "toggle_bb_active_svg__Path_9746",
  d: "M3.836 2.224l1.019.267-3.026 3.453-.886-.783z",
  className: "toggle_bb_active_svg__cls-2",
  transform: "translate(15.043 -1.982)"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "toggle_bb_active_svg__Path_9747",
  d: "M3.651.913L4.99 1 2.017 5H.47z",
  className: "toggle_bb_active_svg__cls-2",
  transform: "translate(15.043 15.018)"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "toggle_bb_active_svg__Path_9748",
  d: "M3.988.971h1.233l-3.772 3.99H-.043z",
  className: "toggle_bb_active_svg__cls-2",
  transform: "translate(.043 15.018)"
});
function SvgToggleBbActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "toggle_bb_active_svg__Component_126_3",
    width: 20.043,
    height: 20.018,
    viewBox: "0 0 20.043 20.018"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_126_3' width='20.043' height='20.018' viewBox='0 0 20.043 20.018'%3e %3cdefs%3e %3cstyle%3e .cls-1,.cls-2%7bfill:rgba(108,255,0,.49)%7d.cls-1%7bstroke:%236cff00%7d.cls-3%7bstroke:none%7d.cls-4%7bfill:none%7d %3c/style%3e %3c/defs%3e %3cg id='Rectangle_7955' class='cls-1'%3e %3cpath d='M0 0H17V17H0z' class='cls-3' transform='translate(.043 3.018)'/%3e %3cpath d='M0.5 0.5H16.5V16.5H0.5z' class='cls-4' transform='translate(.043 3.018)'/%3e %3c/g%3e %3cg id='Rectangle_7956' class='cls-1'%3e %3cpath d='M0 0H16V16H0z' class='cls-3' transform='translate(4.043 .018)'/%3e %3cpath d='M0.5 0.5H15.5V15.5H0.5z' class='cls-4' transform='translate(4.043 .018)'/%3e %3c/g%3e %3cpath id='Path_9749' d='M0 0h16l-3.7 3.4H-3.238l1.461-1.536z' class='cls-2' transform='translate(4.043 .018)'/%3e %3cpath id='Path_9750' d='M12.249 2.959L16 0l-.355 16-3.019 3.135z' class='cls-2' transform='translate(4.043 .018)'/%3e %3cpath id='Path_9745' d='M4.027 1.982l1.595.1-3.917 3.1L0 5z' class='cls-2' transform='translate(.043 -1.982)'/%3e %3cpath id='Path_9746' d='M3.836 2.224l1.019.267-3.026 3.453-.886-.783z' class='cls-2' transform='translate(15.043 -1.982)'/%3e %3cpath id='Path_9747' d='M3.651.913L4.99 1 2.017 5H.47z' class='cls-2' transform='translate(15.043 15.018)'/%3e %3cpath id='Path_9748' d='M3.988.971h1.233l-3.772 3.99H-.043z' class='cls-2' transform='translate(.043 15.018)'/%3e %3c/svg%3e";
export { SvgToggleBbActive as ReactComponent };